export default __webpack_public_path__ + "static/media/Vector.b4349414.svg";